import axios from "axios";
import * as types from "../mutation-types";

// state
export const state = {
    cursos: null
};

// getters
export const getters = {
    cursos: state => state.cursos
};

// mutations
export const mutations = {
    [types.FETCH_CURSOS_SUCCESS](state, {cursos}) {
        state.cursos = cursos
    },
    [types.FETCH_CURSOS_FAILURE] (state) {
        state.cursos = null
    }
};

// actions
export const actions = {
    async fetchAllCursos({commit}) {
        try {
            const {data: {data}} = await axios.get("/api/cursos");

            commit(types.FETCH_CURSOS_SUCCESS, {cursos: data});
        } catch (e) {
            commit(types.FETCH_CURSOS_FAILURE);
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/cursos.js